module.exports = __webpack_public_path__ + "img/trash.2.fa387de2.svg";